import React from "react";
import styles from "./grid.module.scss";

export function Grid(props: React.PropsWithChildren<unknown>): JSX.Element {
  return <div className={styles.container}>{props.children}</div>;
}
